import { combineReducers } from 'redux';
import concat from 'lodash/concat';

import {
    POP_ORGANIZER,
    SET_ORGANIZERS,
    SET_ORGANIZER_CATEGORIES,
} from 'consumer-utils/redux/organizers/actionTypes';

import { ORGANIZER_POPULAR_CATEGORIES } from 'consumer-utils/constants/categories';
import { location as locationDuck } from '@eb/destination-utils';

import { SET_PROFILES_LOADING } from '../app/actions';

import { ADD_ORGANIZER_USER_FOLLOW } from './actions';

const {
    actionTypes: { UPDATE_LOCATION },
} = locationDuck;

/*
Note: Soon this reducer should be refactored to handle responses from /organizers/suggestions/,
which look like:
{
    "EventbriteCategory/103": [
        {
            "organizer": {
                "_type": "destination_profile",
                "num_upcoming_events": null,
                "name": "Slim's",
                "summary": "Slim\u2019s is ALL AGES (6+) \r\n333 11th St. San Francisco, CA",
                "event": {
                    "id": "55737403073",
                    "tickets_url": "https://www.evbqa.com/e/haley-reinhart-slims-w-joseph-luca-tickets-55737403073",
                    "tickets_by": "Eventbrite",
                    "primary_organizer_id": "8103006760",
                    "start_date": "2019-04-25",
                    "end_time": "23:59",
                },
            },
        },
    ],
}
*/

const areProfilesLoading = (state = false, { type, payload }) => {
    let newState = state;

    if (type === SET_PROFILES_LOADING) {
        newState = payload;
    }

    return newState;
};

const entities = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === POP_ORGANIZER) {
        nextState = {
            ...nextState,
            [payload.categoryId]: nextState[payload.categoryId].filter(
                ({ organizer }) => organizer.id !== payload.organizerId,
            ),
        };

        if (nextState[payload.categoryId].length === 0) {
            delete nextState[payload.categoryId];
        }
    }

    if (type === SET_ORGANIZERS) {
        nextState = payload;
    }

    return nextState;
};

const organizersExcluded = (state = [], { type, payload }) => {
    let organizersExcluded = state;

    if (type === POP_ORGANIZER) {
        organizersExcluded = concat(organizersExcluded, payload.organizerId);
    }

    return organizersExcluded;
};

const remainingCategories = (
    state = ORGANIZER_POPULAR_CATEGORIES,
    { type, payload },
) => {
    let nextState = state;

    if (type === SET_ORGANIZER_CATEGORIES) {
        nextState = payload;
    }

    if (type === UPDATE_LOCATION) {
        nextState = ORGANIZER_POPULAR_CATEGORIES;
    }

    return nextState;
};

const organizersUserFollow = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === ADD_ORGANIZER_USER_FOLLOW) {
        nextState = payload;
    }

    return nextState;
};

export default combineReducers({
    entities,
    areProfilesLoading,
    organizersExcluded,
    organizersUserFollow,
    remainingCategories,
});
